module.exports = __webpack_public_path__ + "img/reshub-logo-300x332.49014ee8.png";